<rid-expressive-reading
  class="h-dvh"
  [steps]="[
    {
      content: 'Ik ben geen fan van rolkoffers. Ze maken een irritant geluid. Dus ik gebruik een backpack.',
      evaluate: true,
      mode: 'CAREFUL',
    },
    {
      content: 'Ik ben geen fan van rolkoffers. Ze maken een irritant geluid! Dus ik gebruik een backpack.',
      evaluate: true,
      mode: 'PUNCTUATION',
    },
    {
      content: 'Ik ben geen fan van rolkoffers. Ze maken een irritant geluid. Dus ik gebruik een backpack.',
      evaluate: false,
      mode: 'EXPRESSIVE',
      expression: [
        '/expressions/alien.png',
        '/expressions/angry.png',
        '/expressions/bored.png',
        '/expressions/crying.png',
        '/expressions/laughing.png',
        '/expressions/monster.png',
      ],
    },
  ]"
  (finished)="$router.navigate(['/mechanics/expression'])"
/>
